<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Forgot Password</h1>
              <p class="text-lead text-white">Enter your email address and we will send you an email to reset your password.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          <div class="card bg-secondary border-0">
            <div class="card-body px-lg-5 py-lg-5">
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <form role="form" @submit.prevent="handleSubmit(register_form)">
            

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              name="Email"
                              :rules="{required: true, email: true}"
                              v-model="model.email">
                  </base-input>

        
       
           
                  <div class="text-center">
                    <button  class="btn btn-primary mt-4" native-type="submit">Reset Password</button>
                  </div>
                </form>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import {UserService} from '@/services/user.service'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
  
  export default {
    name: 'register',
    data() {
      return {
        model: {
          name: '',
          email: '',
          password: '',
          confirm_password:'',
          agree: false
        }
      }
    },
    methods: {
      
      async register_form() {
      	 swal.showLoading();
      	const vm = this;
        let uri = this.$base_url+'/api/v1/client_forgot_password';
       	ApiService.post(uri, this.model).then(response => {
         		
         		
         	
         		if(response.data.message == "not_exist"){
         				swal.fire({
							title: `Oops`,
							text: "There is no existing account with this email address. Please check and try again.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
         		}
         		else if(response.data.message == "passwords.sent"){
         			if(response.data.data =="passwords.throttled"){
         				swal.fire({
							title: `Oops`,
							text: "You have tried to reset your password too many times. Please wait 3 minutes and try again.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
         			}
         			else{
         			 swal.fire({
							title: `Success`,
							text: 'We have sent you an email with a link to reset your password.',
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-success',
							icon: 'success'
						  });
         			}
         		}//end if-else
				
      		})
        
      }//end register_form
    }

  };
</script>
<style></style>











